moment = require('moment')

module.exports = ->
  (dateTime, round = 15) ->
    date = moment(dateTime)
    rounded = Math.ceil(date.minute() / round) * round
    date.minute(rounded).second(0).milliseconds(0).toDate()
